import React from 'react';
import * as faceapi from 'face-api.js';
import Box from '../components/Box';

class Receptionist extends React.Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.cameraRef = React.createRef();
        this.canvasRef = React.createRef();
        this.state = {
            videoStarted: false,
            message: 'Esperando detectar una cara...'
        };
    }

    async componentDidMount() {
        await faceapi.nets.tinyFaceDetector.loadFromUri('/models/tiny_face_detector');
        const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: 'user' // 'user' = front camera
            },
            audio: false
        })
        this.cameraRef.current.srcObject = stream;

        this.cameraRef.current.onloadeddata = () => {
            this.startFaceDetection();
        };
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        if (this.cameraRef.current?.srcObject) {
            this.cameraRef.current.srcObject.getTracks().forEach(track => track.stop());
        }
    }

    startFaceDetection() {
        this.interval = setInterval(async () => {
            if (!this.cameraRef.current || this.state.videoStarted) return;

            const detections = await faceapi.detectAllFaces(
                this.cameraRef.current,
                new faceapi.TinyFaceDetectorOptions()
            );

            // Draw detections
            const canvas = this.canvasRef.current;
            const dims = faceapi.matchDimensions(canvas, this.cameraRef.current, true);
            const resized = faceapi.resizeResults(detections, dims);
            faceapi.draw.drawDetections(canvas, resized);

            if (detections.length > 0) {
                this.setState({
                    videoStarted: true,
                    message: '¡Cara detectada! Reproduciendo saludo...'
                }, () => {
                    const videoEl = this.videoRef.current;
                    videoEl.muted = false;
                    videoEl.play();
                });
            }
        }, 500);
    }

    handleVideoEnd = () => {
        this.setState({
            videoStarted: false,
            message: 'Esperando detectar una cara...'
        });

        // Clear canvas after video
        const canvas = this.canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    };

    render() {
        return (
            <div>
                <div className="text-center">
                    <div style={{ position: 'relative', overflow: 'visible', width: '100vw', height: 'auto' }}>
                        <video
                            ref={this.videoRef}
                            src="/videos/remember-shift.mp4"
                            controls={false}
                            muted={false} // unmute explicitly if you intend audio playback
                            autoPlay={false} // explicitly handle playback with videoEl.play()
                            playsInline
                            preload="auto" // Ensure preload to reduce playback latency
                            webkit-playsinline="true" // Explicitly for iOS older browsers
                            onLoadedData={() => console.log("✅ Video loaded")}
                            onError={() => console.error("❌ Video failed to load")}
                            onEnded={this.handleVideoEnd}
                            style={{
                                display: 'block',
                                width: '100vw',
                                height: 'auto' // maintain aspect ratio
                            }}
                        />

                        <div style={{
                            position: 'absolute',
                            bottom: '0',
                            left: '0',
                            backgroundColor: 'black',
                            padding: '0',
                            borderRadius: '0',
                            display: 'flex',
                            alignItems: 'center',
                            color: 'white',
                            width: '100vw',
                            height: '60px'
                        }}>
                            <img src="/images/logo.png" alt="Logo" style={{ height: '40px', marginRight: '10px', margin: 'auto' }} />
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <video
                            ref={this.cameraRef}
                            width="256"
                            height="256"
                            autoPlay
                            muted
                            style={{ position: 'absolute', top: 0, left: 0 }}
                            playsInline
                        />
                        <canvas
                            ref={this.canvasRef}
                            width="256"
                            height="256"
                            style={{ position: 'absolute', top: 0, left: 0 }}
                        />
                    </div>
                    <p className="mt-3" style={{ display: 'inline-block', marginLeft: '256px', paddingTop: '70px' }}>{this.state.message}</p>
                </div>
            </div>
        );
    }
}

export default Receptionist;
